export function filterComponentProps(props) {
    return {
        className: props.className,
        children: props.children,
        onKeyDown: props.onKeyDown,
        onClick: props.onClick,
    };
}
